export interface DoctorNameParts {
  fullName?: string | null;
  title?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

const normalize = (value?: string | null): string =>
  (value ?? '').toString().trim();

const normalizeLower = (value?: string | null): string =>
  normalize(value).toLocaleLowerCase();

export const formatDoctorName = (parts: DoctorNameParts): string => {
  const title = normalize(parts.title);
  const firstName = normalize(parts.firstName);
  const lastName = normalize(parts.lastName);
  const fullName = normalize(parts.fullName);

  const baseName =
    firstName && lastName ? `${firstName} ${lastName}` : fullName;

  if (!title) {
    return baseName;
  }

  const baseLower = normalizeLower(baseName);
  const titleLower = normalizeLower(title);

  if (baseLower.startsWith(titleLower)) {
    return baseName;
  }

  if (!baseName) {
    return title;
  }

  return `${title} ${baseName}`;
};
